import { Vue, VueRouter, Vuex } from './vue-loader';
import ACClient from './api-layer/ACClient';
import BaseClient from './api-layer/BaseClient';
import RecipeBaseClient from './api-layer/RecipeBaseClient';
import apiLayerUtils from './api-layer/apiLayerUtils';
import APILayerConsts from './api-layer/consts';
import EventEmitter from './lib/EventEmitter';
import BaseVueRouter from './base/BaseVueRouter';
import AppFactory from './factory/AppFactory';
import RouterFactory from './factory/RouterFactory';
import StoreFactory from './factory/StoreFactory';
import FrameworkPlugin from './plugin/FrameworkPlugin';
import StorePlugin from './plugin/StorePlugin';
import * as infraStore from './store';
import * as sessionKeys from './auth/session/keys';
import lpStorage from './lib/lpStorage';
import lpCookie from './lib/lpCookie';
import * as infraMutationsTypes from './store/infra/mutation-types';
import * as sessionGetterTypes from './store/modules/session/getter-types';
import * as sessionActionTypes from './store/modules/session/action-types';
import { SESSION_STATE_KEY as sessionStateKeys } from './store/modules/session/keys';
import * as environmentActionTypes from './store/modules/environment/actionTypes';
import * as environmentGetterTypes from './store/modules/environment/getterTypes';
import * as environmentMutationTypes from './store/modules/environment/mutationTypes';
import { ENVIRONMENT_STATE_KEY as environmentStateKeys, AGENT_STATUS_DATA_STATES } from './store/modules/environment/keys';
import * as storeModuleTypes from './store/types';
import gChannel from './lib/gChannel';
import TransportLayer from './auth/transportLayer/TransportLayer';
import Logger from './logger/logger';
import LoggerConstants from './logger/Const';
import ConsoleAppender from './logger/appenders/ConsoleAppender';
import RemoteLoggosAppender from './logger/appenders/RemoteLoggosAppender';
import AbstractAppender from './logger/appenders/AbstractAppender';
import RemoteLoggosBamAppender from './logger/appenders/RemoteLoggosBamAppender';
import commonUtils from './utils';
import sessionManager from './auth/session/sessionManager';
import sessionModel from './auth/session/sessionModel';
import CustomRingsManager from './customRings/CustomRingsManager';
import i18n from './manager/i18n';
import pack from './../package.json';
import COMMON_CONSTANTS from './assets/common-constants-ids.json';
import ACCOUNT_SETTINGS_IDS from './assets/account-settings-ids.json';
import COMPOUND_FEATURES_IDS from './assets/compound-features-ids.json';
import PRIVILEGES from './assets/privileges.json';
import { registerNetworkLogger } from './logger/appenders/NetworkAppender';

const version = pack.version;
window.addEventListener('load', registerNetworkLogger);
//
export { Vue };
export { Vuex };
export { VueRouter };
export { BaseVueRouter };
export { AppFactory };
export { RouterFactory };
export { StoreFactory };
export { FrameworkPlugin };
export { StorePlugin };
export { infraStore };
export { sessionModel };
export { lpStorage };
export { lpCookie };
export { sessionGetterTypes };
export { sessionActionTypes };
export { sessionKeys };
export { sessionStateKeys };
export { environmentActionTypes };
export { environmentGetterTypes };
export { infraMutationsTypes };
export { environmentMutationTypes };
export { environmentStateKeys };
export { AGENT_STATUS_DATA_STATES };
export { storeModuleTypes };
export { gChannel };
export { TransportLayer };
export { sessionManager };
export { CustomRingsManager };
export { Logger };
export { LoggerConstants };
export { ConsoleAppender };
export { RemoteLoggosAppender };
export { RemoteLoggosBamAppender };
export { AbstractAppender };
export { COMMON_CONSTANTS };
export { ACCOUNT_SETTINGS_IDS };
export { COMPOUND_FEATURES_IDS };
export { PRIVILEGES };
export { commonUtils };
export { ACClient };
export { BaseClient };
export { RecipeBaseClient };
export { APILayerConsts };
export { EventEmitter };
export { i18n };
export { version };
export { apiLayerUtils };
export { registerNetworkLogger };



// WEBPACK FOOTER //
// ./src/index.js